var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificaciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41.7811,
    height: 39,
    rx: 8.5,
    stroke: "#0075BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8139 31.8975C19.6292 31.8975 17.8523 30.2421 17.8523 28.2069C17.8523 27.7994 18.2073 27.4688 18.6446 27.4688C19.082 27.4688 19.4369 27.7994 19.4369 28.2069C19.4369 29.4283 20.503 30.4213 21.8139 30.4213C23.125 30.4213 24.1908 29.4283 24.1908 28.2069C24.1908 27.7994 24.5458 27.4688 24.9831 27.4688C25.4205 27.4688 25.7755 27.7994 25.7755 28.2069C25.7755 30.2421 23.9985 31.8975 21.8139 31.8975Z",
    fill: "#0075BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2796 28.6662H12.8487C11.8293 28.6662 11 27.8164 11 26.7718C11 26.2173 11.2356 25.6924 11.6465 25.3318C13.2533 23.9407 14.1693 21.9186 14.1693 19.7761V16.7577C14.1693 12.5791 17.4865 9.17969 21.5641 9.17969C25.6419 9.17969 28.9592 12.5791 28.9592 16.7577V19.7761C28.9592 21.9186 29.8751 23.9407 31.4713 25.3243C31.8928 25.6924 32.1284 26.2173 32.1284 26.7718C32.1284 27.8164 31.2992 28.6662 30.2796 28.6662ZM21.5641 10.8036C18.36 10.8036 15.7539 13.4743 15.7539 16.7577V19.7761C15.7539 22.3969 14.6331 24.8718 12.6798 26.5638C12.6427 26.5963 12.5846 26.6635 12.5846 26.7718C12.5846 26.9189 12.7051 27.0423 12.8487 27.0423H30.2796C30.4233 27.0423 30.5438 26.9189 30.5438 26.7718C30.5438 26.6635 30.4856 26.5963 30.4507 26.566C28.4953 24.8718 27.3745 22.3969 27.3745 19.7761V16.7577C27.3745 13.4743 24.7684 10.8036 21.5641 10.8036Z",
    fill: "#0075BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificaciones);
export default __webpack_public_path__ + "static/media/notificaciones.16e2dc7ad6e10baf97ba4d47f718cda1.svg";
export { ForwardRef as ReactComponent };